
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface ContainerProps {
  children: ReactNode;
  className?: string;
  id?: string;
  as?: keyof JSX.IntrinsicElements;
}

export function Container({ 
  children, 
  className, 
  id,
  as: Component = "div" 
}: ContainerProps) {
  return (
    <Component
      id={id}
      className={cn(
        "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full box-border",
        className
      )}
    >
      {children}
    </Component>
  );
}
